<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_tab_second') }}</v-tab>
      <v-tab-item value="tab-1">
        <new-discount-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :discountItemList="discountItemList"
          @setAllDiscount="setAllDiscount"
          @deleteDiscountItem="deleteDiscountItem"
          @setDiscountItem="setDiscountItem"
          @setDiscountItemIndex="setDiscountItemIndex"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import NewDiscountSetting from '@/components/Quotation/DiscountItem/NewDiscountSetting.vue'
export default {
  components: { NewDiscountSetting },
  name: 'Discount',

  data: () => ({}),
  watch: {
    carQuantity (val) {
      if (this.monthItemList.length > 0) {
        this.monthItemList.forEach((element) => {
          if (element.MonthBomItems && element.MonthBomItems.length > 0) {
            element.MonthBomItems.forEach((ele) => {
              ele.RentQuantity = val
              ele.TotalPrice = val * ele.DiscountPrice * ele.Quantity
            })
          }
          element.RentQuantity = val
          element.TotalPrice = val * element.DiscountPrice * element.Quantity
        })
      }
    }
  },
  methods: {
    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    }
  },
  props: [
    'isAllTextFieldDisabled',
    'monthItemList',
    'carQuantity',
    'allPayType',
    'discountItemList'
  ]
}
</script>
